(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/wager/assets/javascripts/paybags.js') >= 0) return;  svs.modules.push('/components/tur/wager/assets/javascripts/paybags.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs = svs || {};
(svs => {
  svs.tur.wager = _objectSpread(_objectSpread({}, svs.tur.wager), {}, {
    payBags(_ref) {
      let {
        isBag,
        productName,
        accountBalance,
        wagers,
        wagerprops,
        success,
        apiSuccess,
        error,
        cannotBeCancelled,
        confirmMessage,
        abortCallback,
        noConfirmDialog,
        noSuccessDialog,
        extraSuccessMessage
      } = _ref;
      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        let calculatedBetAmount = 0;
        wagers.forEach(wager => {
          wager.bets.forEach(bet => {
            calculatedBetAmount += isNaN(parseInt(bet.betAmountSalesGroup1, 10)) ? 0 : parseInt(bet.betAmountSalesGroup1, 10);
            calculatedBetAmount += isNaN(parseInt(bet.betAmountSalesGroup2, 10)) ? 0 : parseInt(bet.betAmountSalesGroup2, 10);
          });
        });
        const playerRegistrationExtraData = {
          amount: wagerprops && (wagerprops.betAmount || wagerprops[0].betAmount) || calculatedBetAmount,
          product: this.CONSTANTS.simpleProductName[wagerprops[0].productId],
          weeks: wagerprops[0].extradata.rounds,
          subscription: false,
          gift: false,
          branding: this.CONSTANTS.simpleProductName[wagerprops[0].productId]
        };
        svs.components.customer_login.login({
          returnNewCustomer: true,
          extraParams: playerRegistrationExtraData
        });
      } else {
        if (this.isPaymentOngoing()) {
          svs.tur.wager.logger.warn('Trying to make another payment during ongoing payment');
        } else {
          svs.components.Storage.browser.set('wagerstart', 'Wager', 1, svs.components.Storage.constants.EXPIRES_10M);

          if (svs.tur.wager.data && _.isEqual(wagers, svs.tur.wager.data.lastwager) && new Date().getTime() - svs.tur.wager.data.lastwagertime.getTime() < 3000) {
            svs.tur.wager.logger.info('PayBags doubleclick payment attempt');
            return false;
          }
          this.productName = productName;
          this.wagers = {
            wagers
          };
          this.wagerprops = wagerprops;
          this.success = success;
          this.apiSuccess = apiSuccess;
          this.error = error;
          this.noConfirmDialog = noConfirmDialog;
          this.noSuccessDialog = noSuccessDialog;
          this.extraSuccessMessage = extraSuccessMessage;
          this.togglePayButton(false);
          this.balance = 0;
          this.trackingWagers = [];
          svs.tur.wager.data = {
            lastwager: wagers,
            lastwagertime: new Date()
          };
          const syndicate = svs.syndicate && svs.syndicate.AccountSelector && svs.syndicate.AccountSelector.getAccountModel();
          if (syndicate && syndicate.isSyndicateActive()) {
            if (/lördagsgodis/i.test(this.productName)) return;
            this.balance = syndicate.get('playableAmount');
          } else {
            this.balance = svs.utils.format.CurrencyFromJupiterString(accountBalance);
          }

          _.each(this.wagers.wagers, (wager, index) => {
            const trackingwager = {
              wagerId: 0,
              totalPrice: 0,
              bets: []
            };
            let productName, day;
            if (syndicate && syndicate.isSyndicateActive()) {
              wager.syndicate = true;
              wager.syndicateId = syndicate.get('syndicateId');
              wagerprops[index].playableAmount = syndicate.get('playableAmount');
              wagerprops[index].syndicateName = syndicate.get('syndicateName');
              wagerprops[index].syndicateId = syndicate.get('syndicateId');
              if (wagerprops[index].jokerextradata) {
                wagerprops[index].jokerextradata.syndicate = wagerprops[index].syndicateName;
              }
              wagerprops[index].extradata = wagerprops[index].extradata || {};
              wagerprops[index].extradata.syndicate = wagerprops[index].syndicateName;
              this.balance = syndicate.get('playableAmount');
              _.each(wager.bets, bet => {
                bet.betProperties = bet.betProperties || [];
                bet.betProperties.push('BOLAG');
              });
            }
            switch (wager.bets[0].productId) {
              case 'ONSLOTTO':
                day = 'Onsdag';
              case 'LORLOTTO':
                day = day || 'Lördag';
                productName = "Lotto 1 ".concat(day);
                break;
              default:
                productName = this.CONSTANTS.productName[wagerprops[index].productId];
            }
            const bet = {
              productName,
              productId: this.wagerprops[index].productId,
              price: svs.utils.format.CurrencyFromJupiterString(wager.bets[0].betAmountSalesGroup1),
              numberOfRows: 1,
              extraData: this.wagerprops[index].extradata
            };
            if (wager.bets[0].productId === 'KENO') {
              bet.price += svs.utils.format.CurrencyFromJupiterString(wager.bets[0].betAmountSalesGroup2);
            }
            trackingwager.totalPrice += bet.price;
            trackingwager.bets.push(bet);
            if (wager.bets[0].lottoBoards && wager.bets[0].lottoBoards[0].participation === 'L1L2') {
              const lotto2 = {
                productName: "Lotto 2 ".concat(day),
                productId: "".concat(wager.bets[0].productId, "2"),
                price: svs.utils.format.CurrencyFromJupiterString(wager.bets[0].betAmountSalesGroup2),
                numberOfRows: 1,
                extraData: this.wagerprops[index].extradata || 'unknown'
              };
              trackingwager.bets.push(lotto2);
              trackingwager.totalPrice += lotto2.price;
            }

            if (wager.bets.length > 1) {
              const jokerWager = {
                productName: "Joker ".concat(day),
                productId: wager.bets[1].productId,
                price: svs.utils.format.CurrencyFromJupiterString(wager.bets[1].betAmountSalesGroup1),
                numberOfRows: 1,
                extraData: this.wagerprops[index].extradata || 'unknown'
              };
              trackingwager.bets.push(jokerWager);
              trackingwager.totalPrice += jokerWager.price;
            }
            this.trackingWagers.push(trackingwager);
          });

          let betAmount = 0;
          if (this.wagerprops[0].betAmount) {
            betAmount = this.wagerprops[0].betAmount;
          }
          if (betAmount > this.balance) {
            svs.events.publish('/loader/hide');
            this.showNoMoneyMessage.call(this, this.balance, betAmount, abortCallback);
          } else {
            if (this.noConfirmDialog) {
              this.sendBagsWagers({
                callback: this.success,
                cannotBeCancelled
              });
            } else {
              this.confirmDialog({
                product: productName || this.CONSTANTS.simpleProductName[this.wagerprops[0].productId],
                isBag: isBag || false,
                price: betAmount,
                balance: this.balance,
                isMultiple: true,
                cannotBeCancelled,
                confirmMessage,
                abortCallback,
                syndicateName: this.wagerprops.length && this.wagerprops[0].syndicateName || false
              });
            }
          }
        }
      }
    },
    sendBagsWagers(_ref2) {
      let {
        callback
      } = _ref2;
      svs.tur.wager.logger.info('sendBagsWagers : ', this.wagers);
      this.payObject = {
        method: 'POST',
        path: '/wager/9/multiwagers',
        data: this.wagers
      };
      svs.events.publish('/loader/show');
      svs.core.jupiter.call(this.payObject, data => {
        svs.tur.wager.logger.info("PayBags response received (".concat(JSON.stringify(data), ")"));
        this.regWagerResponse = data;
        this.togglePayButton(true);
        let balance = -1;
        _.each(this.regWagerResponse.regWagerResults, (regWagerResult, index) => {
          if (regWagerResult.status === 'SUCCESS') {
            this.trackingWagers[index].productName = this.productName;
            this.trackingWagers[index].wagerId = regWagerResult.regWagerResult.wagerClientSerial;
            balance = svs.utils.format.CurrencyFromJupiterString(regWagerResult.regWagerResult.accountBalance);
            this.trackGA(this.trackingWagers[index]);
          }
        });
        if (balance > -1) {
          svs.components.account_balance.set(balance);
        }
        svs.events.publish('/loader/hide');
        svs.components.Storage.browser.remove('wagerstart', 'Wager');
        if (svs.syndicate && svs.syndicate.AccountSelector) {
          const accountModel = svs.syndicate.AccountSelector.getAccountModel();
          if (accountModel.get('isSyndicate')) {
            setTimeout(() => {
              accountModel.fetch({
                parse: true
              });
            }, 2000);
          } else {
            svs.syndicate.AccountSelector.updateUserBalance();
          }
        }

        if (!this.noConfirmDialog) {
          callback && callback(data);
        }
        if (this.noSuccessDialog) {
          this.success && this.success(data);
        } else {
          this.successDialog(data);
        }
        typeof this.apiSuccess === 'function' && this.apiSuccess(data);
      }, (jqXHR, textStatus, errorThrown) => {
        let errorCode = 777,
          response;
        if (jqXHR.responseText) {
          response = JSON.parse(jqXHR.responseText);
          if (response.error && typeof response.error.code === 'string') {
            errorCode = parseInt(response.error.code.replace(/\s/g, ''), 10);
          }
        }
        svs.tur.wager.logger.warn("PayBags failure (".concat(JSON.stringify(jqXHR), ", ").concat(textStatus, ", ").concat(errorThrown, ", ").concat(errorCode, ")"));

        const gotErrors = this.handleError(errorCode, response);
        if (gotErrors) {
          this.error(gotErrors);
        }
        this.togglePayButton(true);
        svs.events.publish('/loader/hide');
        svs.components.Storage.browser.remove('wagerstart', 'Wager');
        callback && callback();
      });
    }
  });
})(svs);

 })(window);